export const ASSET_ROOT_GET_DATA = 'ASSET_ROOT_GET_DATA'
export const ASSET_ROOT_GET_DATA_SUCCESS = 'ASSET_ROOT_GET_DATA_SUCCESS'
export const ASSET_ROOT_GET_DATA_FAILURE = 'ASSET_ROOT_GET_DATA_FAILURE'
export const ASSET_ROOT_EMPTY = 'ASSET_ROOT_EMPTY'
export const ASSET_ROOT_ACTIVEVIEW = 'ASSET_ROOT_ACTIVEVIEW'

export const ASSET_ROOT_EDIT_SELECT = 'ASSET_ROOT_EDIT_SELECT'
export const ASSET_ROOT_EDIT_UNSET_SELECT = 'ASSET_ROOT_EDIT_UNSET_SELECT'
export const ASSET_ROOT_EDIT = 'ASSET_ROOT_EDIT'
export const ASSET_ROOT_EDIT_SUCCESS = 'ASSET_ROOT_EDIT_SUCCESS'
export const ASSET_ROOT_EDIT_FAILURE = 'ASSET_ROOT_EDIT_FAILURE'

export const ASSET_ROOT_DELETE = 'ASSET_ROOT_DELETE'
export const ASSET_ROOT_DELETE_SUCCESS = 'ASSET_ROOT_DELETE_SUCCESS'
export const ASSET_ROOT_DELETE_FAILURE = 'ASSET_ROOT_DELETE_FAILURE'

export const ASSET_ROOT_SHARE_SELECT = 'ASSET_ROOT_SHARE_SELECT'
export const ASSET_ROOT_SHARE_UNSET_SELECT = 'ASSET_ROOT_SHARE_UNSET_SELECT'

export const ASSET_ROOT_CHECK_SELECT = 'ASSET_ROOT_CHECK_SELECT'
export const ASSET_ROOT_UNCHECK_SELECT = 'ASSET_ROOT_UNCHECK_SELECT'

export const MULTIPLE_ROOT_OPTIONS_ACTIVATE = 'MULTIPLE_ROOT_OPTIONS_ACTIVATE'
export const MULTIPLE_ROOT_OPTIONS_DEACTIVATE = 'MULTIPLE_ROOT_OPTIONS_DEACTIVATE'
export const MULTIPLE_ROOT_OPTIONS_DONE = 'MULTIPLE_ROOT_OPTIONS_DONE'

export const ASSET_ROOT_UPDATE_FROM_PERMISSION = 'ASSET_ROOT_UPDATE_FROM_PERMISSION'

export const ASSETS_ROOT_MULTI_DELETE = 'ASSETS_ROOT_MULTI_DELETE'
export const ASSETS_ROOT_MULTI_DELETE_SUCCESS = 'ASSETS_ROOT_MULTI_DELETE_SUCCESS'
export const ASSETS_ROOT_MULTI_DELETE_FAILURE = 'ASSETS_ROOT_MULTI_DELETE_FAILURE'

export const ASSETS_ROOT_MULTI_MOVE = 'ASSETS_ROOT_MULTI_MOVE'
export const ASSETS_ROOT_MULTI_MOVE_SUCCESS = 'ASSETS_ROOT_MULTI_MOVE_SUCCESS'
export const ASSETS_ROOT_MULTI_MOVE_FAILURE = 'ASSETS_ROOT_MULTI_MOVE_FAILURE'

export const CLEAN_DATA_BACK_ROOT = 'CLEAN_DATA_BACK_ROOT'
export const SCROLL_ROOT = 'SCROLL_ROOT'
